export default {
  primary: {
    50: '#ffe7e7',
    100: '#ffb7b7',
    200: '#ff5959',
    300: '#ff1212',
    400: '#de0000',
    500: '#c40000', //
    600: '#aa0000',
    700: '#910000',
    800: '#770000',
    900: '#5e0000',
    A100: '#c89999',
    A200: '#ad6666',
    A400: '#923232',
    A700: '#770000',
  },
  secondary: {
    50: '#e4e8eb',
    100: '#c9d2d7',
    200: '#aebcc3',
    300: '#93a6af',
    400: '#78909c',
    500: '#60737c',
    600: '#48565d',
    700: '#30393e',
    800: '#242b2e',
    900: '#181c1f',
    A100: '#c9d2d7',
    A200: '#78909C',
    A400: '#60737c',
    A700: '#48565d',
  },
};



// WEBPACK FOOTER //
// ./src/styles/mui-palette.js